import React, { FC } from 'react';
import { Paper, Box } from '@mui/material';
import { OrderEvent, OrderEventType } from 'models/order-event';
import EventRecordTitle from 'components/shared/order-events-timeline/order-events/event-record-title.component';
import { eventOrganizationName } from 'components/shared/order-events-timeline/event-organization';
import { useTranslation } from 'react-i18next';

type EventMessageProps = {
    item: OrderEvent;
    displayOrderLabel?: boolean;
};
const EventMessage: FC<EventMessageProps> = ({ item, displayOrderLabel }: EventMessageProps) => {
    const { t: translate } = useTranslation(['order-event']);

    const eventTitle = () => {
        const userOrg = eventOrganizationName(item, translate('order-event:API_INTEGRATION'));
        if (item.type === OrderEventType.NEW_CHAT_MESSAGE) {
            return `${translate('CHAT_FROM')} ${userOrg}`;
        }
        return `${translate('COMMENT_FROM')} ${userOrg}`;
    };

    const userFullName = () => {
        if (item.user) {
            return item.user.fullName;
        }
        return '';
    };

    const newlineText = (text: string | undefined) => {
        if (text) {
            return text
                .replaceAll('<br/>', '\n')
                .replaceAll('<p>', '\n\n')
                .replaceAll('</p>', '')
                .split('\n')
                .map((str: string, index) => (
                    <span key={index}>
                        {str}
                        <br />
                    </span>
                ));
        }
        return undefined;
    };

    return (
        <Paper variant="outlined">
            <Box p={2}>
                <EventRecordTitle
                    title={eventTitle()}
                    item={item}
                    color={item.color}
                    displayOrderLabel={displayOrderLabel}
                />
                <Box mt={1}>
                    {item.user && <em>{userFullName()}: </em>}
                    {newlineText(item.message)}
                </Box>
            </Box>
        </Paper>
    );
};

export default EventMessage;
